/**
 * Progress indicator shown inside the tooltip card.
 * Renders pill-shaped dots: filled = visited, wider = current, hollow = upcoming.
 * Falls back to "N / Total" text when the step count is too large for dots.
 */

const MAX_DOTS = 12;

type OnboardingProgressProps = {
  current: number;
  total: number;
};

export const OnboardingProgress = ({
  current,
  total,
}: OnboardingProgressProps) => {
  if (total > MAX_DOTS) {
    return (
      <p className="text-xs text-gray-500 text-center">
        {current + 1} / {total}
      </p>
    );
  }

  return (
    <div className="flex items-center justify-center gap-1">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className="rounded-full transition-all duration-300"
          style={{
            width: i === current ? 16 : 6,
            height: 6,
            backgroundColor:
              i === current
                ? 'rgba(99, 179, 237, 1)'
                : i < current
                  ? 'rgba(99, 179, 237, 0.4)'
                  : 'rgba(75, 85, 99, 0.6)',
          }}
        />
      ))}
    </div>
  );
};
